import React from 'react';

import { Redirect, useLocalSearchParams } from 'expo-router';
import { useDragonBallTakeoverExposureEligibility } from 'features/app-takeover/hooks/use-app-takeover';
import { MenuSection } from 'features/menu/pages/menu-object-page/menu-section';
import { MenuSectionPage } from 'features/menu/pages/menu-section-page/menu-section-page';
import { useStoreRequired } from 'features/store/hooks/use-store-required';
import { View } from 'react-native';

import { FloatingViewCartFab } from 'components/floating-view-cart-fab';
import { useDragonBallExperiment } from 'experiments/use-dragon-ball-experiment';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { useMainMenuContext } from 'state/menu/main-menu';
import { routes } from 'utils/routing';

export default function MenuSectionRoute() {
  const { noStoreSelected } = useStoreRequired();

  if (noStoreSelected) {
    return <Redirect href={routes.menu} />;
  }

  return <MenuSectionInner />;
}

const MenuSectionInner = React.memo(() => {
  const { id } = useLocalSearchParams<{ id: string }>();
  const enableUnifiedMenu = useEnableUnifiedMenu();
  const {
    isActive: isDragonBallTakeoverActive,
    targetSectionIds,
  } = useDragonBallTakeoverExposureEligibility();
  const { activeDayParts } = useMainMenuContext();
  const isDragonBallTargetSection = Boolean(id && targetSectionIds?.[id]);

  useDragonBallExperiment(
    !isDragonBallTakeoverActive || !isDragonBallTargetSection,
    activeDayParts
  );

  return (
    <View testID="menu-section-page" style={{ flex: 1 }}>
      {enableUnifiedMenu ? <MenuSectionPage /> : <MenuSection />}
      <FloatingViewCartFab safeAreaBottom />
    </View>
  );
});
